"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPalette = void 0;
const react_1 = __importDefault(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const defaultColorPalette = ["#E2EAC2", "#165152", "#C1C6CA", "#D1102B", "#FE4F00", "#F8DD01", "#FFC525", "#653C20", "#009843", "#000000", "#FFFFFF", "#056647", "#071F5D", "#0082CD", "#0099A7", "#783DBE", "#E51994", "#7B2F3C"];
const ColorPalette = (props) => {
    const { colorPaletteColors } = props;
    let colors = defaultColorPalette;
    if (colorPaletteColors) {
        colorPaletteColors.forEach((color, index) => {
            colors[index] = color;
        });
    }
    const updateColor = (color) => {
        if (props.color.getHex() != color) {
            props.color.setHex(color);
            props.color.setAlpha(1);
            props.color.updateRGBFromHex();
            props.color.updateHSVFromRGB();
            props.color.updateColorSelectors();
            props.color.handleCallback();
        }
    };
    return (react_1.default.createElement("div", { className: ColorPicker_module_css_1.default.color_palette, "data-cy": "ColorPickerPalette" }, colors.map((color, index) => {
        return (react_1.default.createElement("div", { key: index + color, onClick: () => updateColor(color), className: ColorPicker_module_css_1.default.color_palette_color, style: {
                "border": (color == "#FFFFFF" ? "1px solid #979797" : "none"),
                "backgroundColor": color
            } }));
    })));
};
exports.ColorPalette = ColorPalette;
